import React from 'react'
import './Input.css';
export default function TextArea({placeholder, height}) {
    return (
        <div className='wrapper__input'>
           <textarea className="input" placeholder={placeholder} rows={5}></textarea>
        </div>
    )
}
